"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorResultNumber = void 0;
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ROICalculatorResultNumber = (0, mobx_react_1.observer)(function (_a) {
    var value = _a.value, containerWidth = _a.containerWidth, prefix = _a.prefix, suffix = _a.suffix;
    var fontMultiplicationFactor = 16;
    if (value.length >= 10) {
        fontMultiplicationFactor = 13;
    }
    if (value.length >= 11) {
        fontMultiplicationFactor = 12;
    }
    if (value.length >= 12) {
        fontMultiplicationFactor = 10;
    }
    if (value.length >= 14) {
        fontMultiplicationFactor = 8;
    }
    var fontSize = containerWidth ? (0, lodash_1.clamp)((containerWidth / 100) * fontMultiplicationFactor, 36, 150) : undefined;
    var lineHeight = containerWidth ? "".concat((0, lodash_1.clamp)((containerWidth / 100) * 16, 36, 150), "px") : undefined;
    return (react_1.default.createElement("div", { className: "roi-calculator-typography__result roi-calculator__result", style: { fontSize: fontSize }, "aria-live": "polite", "aria-atomic": "true" },
        react_1.default.createElement("span", { className: "roi-calculator-typography__result-prefix roi-calculator-typography__result-affix" }, prefix),
        react_1.default.createElement("span", { className: "roi-calculator-typography__result-value", style: { lineHeight: lineHeight } }, value),
        react_1.default.createElement("span", { className: "roi-calculator-typography__result-suffix roi-calculator-typography__result-affix" }, suffix)));
});
exports.ROICalculatorResultNumber = ROICalculatorResultNumber;
